import { lazy } from 'solid-js'
import { messages } from '../../pages/tos-page/tos-page-routing.messages.en.js'

export default {
    component: lazy(() => import('../../pages/tos-page/tos-page.jsx')),
    descriptionMessage: messages.descriptionMessage,
    path: '/tos',
    titleMessage: messages.titleMessage,
}
